import { AutocompleteProps, TextFieldProps } from '@mui/material'
import { useGetProjectCategories } from '@/service-library/hooks/project-categories'
import { ProjectCategory } from '@/types/projects'
import ListAutocomplete from '@/components/list-autocomplete/ListAutocomplete'

type ProjectCategoryAutocompleteProps = {
  selected: ProjectCategory
  onCategoryChange: (category: ProjectCategory) => void
  helperText?: string
  variant?: TextFieldProps['variant']
  label?: string
  size?: string
} & Partial<
  AutocompleteProps<ProjectCategory, false, true | false, false, 'div'>
>

export default function ProjectCategoryAutocomplete({
  selected,
  onCategoryChange,
  variant,
  label = 'Project Category',
  size = 'small',
  ...props
}: ProjectCategoryAutocompleteProps) {
  const { projectCategories = [] } = useGetProjectCategories({
    filters: {
      limit: '1000',
    },
  })

  return (
    <ListAutocomplete<ProjectCategory>
      autoSelect={false}
      inputSize={size}
      label={label}
      selected={selected}
      setSelected={(value) => {
        if (!value) return
        onCategoryChange(value)
      }}
      variant={variant}
      {...props}
      options={projectCategories}
    />
  )
}
